import { Routes } from '@angular/router';
import { ReportList } from './report/report-list/report-list';
import { CreateReportTypeComponent } from './report/create-report-type/create-report-type';
import { ReportSections } from './report/report-sections/report-sections';
import { GenerateReport } from './report/generate-report/generate-report';
import { DocumentPreviewComponent } from './report/document-preview-component/document-preview-component';
import { AuthGuard } from './auth/auth.guard';
import { Unauthorized } from './unauthorized/unauthorized';

export const routes: Routes = [
  { path: '', redirectTo: 'reports', pathMatch: 'full' },

  { path: 'reports', component: ReportList, canActivate: [AuthGuard] },
  { path: 'report-types', component: CreateReportTypeComponent, canActivate: [AuthGuard] },
  { path: 'report-sections', component: ReportSections, canActivate: [AuthGuard] },
  { path: 'generate-report', component: GenerateReport, canActivate: [AuthGuard] },
  { path: 'preview-report', component: DocumentPreviewComponent, canActivate: [AuthGuard] },
  { path: 'unauthorized', component: Unauthorized },
];

